import { axiosInstance } from '../../helpers/api_helper';

const updateSubscription = async (formData: any) => {
  try {
    console.log('FormData in uupdate subcription:', formData);

    const response = await axiosInstance.patch(`/FrontPage/UpdatePage`, formData);

    console.log('API Response from update subcription:', response); // Log the response

    if (response.data.message === "Successfull") {
      // Handle success, if needed
      return response.data;
    } else {
      // Handle error
      throw new Error('Error updating store details');
    }
  } catch (error:any) {
    // Handle network or other errors
    throw new Error(`Error: ${error.message}`);
  }
};

export { updateSubscription };
